export default __webpack_public_path__ + "static/media/Check4Cancer-Header-Banner_375x160.cdce58db.jpg";